<template>
  <div class="branding">
    <div class="logo">
      <img
        class="logo-image"
        src="https://static.nuonuo.com.cn/zycmp/icon-196.png">
    </div>
    <div class="text">
      <span>二手车是十分复杂的非标商品，很多地方我们还做不到 100 分；</span>
      <span>但凭借绝对的诚实和相对的专业，至少能让二手车更透明，更敢买。</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandComponent',

  data () {
    return {}
  },

  methods: {},
}
</script>

<style lang="scss" scoped>
.branding {
  width: 100%;
  padding: 10px 5%;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  background: var(--background);
}

.branding .logo {
  width: 10%;
}

.branding .logo .logo-image {
  width: 30px;
  height: 30px;
}

.branding span {
  display: block;
  margin-bottom: 2px;
  color: #999999;
  text-align: center;
  white-space: nowrap;
  width: 85%;
  font-size: .7rem;
}
</style>
